import { IAppStatus, ICategorys, ISoftConfig } from "@/common/interface";
import { SoftStatus, OpenType } from "@q/softCore";
import React from "react";
import { connect } from "react-redux";
import DownloadBtn from "./DownloadBtn";
import Link from "../Link";
import { statusClassName, openTypeText } from "@/common/softConfig";
import classnames from "classnames";

interface IProps {
  softId: number;
  name: string;
  className?: string;
  installed?: boolean;
  configData: ISoftConfig;
  onClick?: (status: number) => void;
  position?: string;
  comAds?: string[];
}

const SoftBtn: React.SFC<IProps> = ({
  softId,
  name,
  comAds,
  configData: {
    open_type,
    open_first = 0,
    exec,
    href,
    btn_text,
    ads,
    category,
    progressName,
  },
  className,
  installed,
  position,
  onClick,
}) => {
  if (
    !open_type ||
    open_type === OpenType.download ||
    (installed && open_first === "1")
  ) {
    return (
      <DownloadBtn
        className={className}
        onClick={onClick}
        softId={softId}
        name={name}
        ads={ads}
        category={category}
        position={position}
        progressName={progressName}
        comAds={comAds}
      />
    );
  }

  const text = btn_text || (openTypeText[open_type] as any);
  const ct =
    category && category.length > 0
      ? `${ICategorys[category]}`
      : `${ICategorys[1]}`;
  return (
    <Link
      className={classnames(
        className,
        statusClassName[SoftStatus.installSucceed],
      )}
      softId={softId}
      href={href}
      exec={exec}
      openType={open_type}
      dataText={`${ct}`}
      type="button"
      ads={ads}
      category={category}
      name={name}
      position={position}
      comAds={comAds}
    >
      {text}
    </Link>
  );
};

const mapStateToProps = (
  { appStatus = {} as IAppStatus },
  { softId }: IProps,
) => ({
  installed:
    appStatus[softId] === SoftStatus.installSucceed ||
    appStatus[softId] === SoftStatus.installedButCannotOpen,
});

export default connect(mapStateToProps)(SoftBtn);
